import { SCOPE_TYPE } from "@model";

/**
 * The extraocular muscle sheet is off unless the org's scope names it, so an org
 * sees it only once someone has decided it should.
 */
export function hasExtraocularMuscleFunction(
  test: { orgScope?: string[] } | null | undefined,
): boolean {
  return Boolean(test?.orgScope?.includes(SCOPE_TYPE.extraocularMuscleFunction));
}
